import Dropdown from '@/js/components/dropdown/dropdown';

const dropdownLinks = [...document.querySelectorAll('.nav-link[data-target-id]')];

// Cookies notice
if (dropdownLinks) {
  // eslint-disable-next-line no-new
  new Dropdown(document.querySelector('.l-site-dropdown'));
}
